import { createDynamicThunk } from ".";

export const getUserListThunk = createDynamicThunk({
  typePrefix: "users/getUserListThunk",
  useHandleSearch: true,
});

export const addUserThunk = createDynamicThunk({
  typePrefix: "users/addUserThunk",
  endpoint: "/users",
  method: "POST",
  refreshList: true,
  listThunk: getUserListThunk,
});

export const editUserThunk = createDynamicThunk({
  typePrefix: "users/editUserThunk",
  endpoint: "/users",
  method: "PUT",
  refreshList: true,
  listThunk: getUserListThunk,
  transformResponse: (response) => response,
});

export const deleteUserThunk = createDynamicThunk({
  typePrefix: "/deleteUserThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getUserListThunk,
});

export const getRoleListThunk = createDynamicThunk({
  typePrefix: "roles/getRoleListThunk",
  endpoint: "/roles/findAll",
  method: "POST",
  transformResponse: (response) =>
    response?.response?.map((role) => ({
      label: role?.name,
      value: role?._id,
    })) || [],
});
